import SectionMixin from '@/mixins/sectionMixin'
import AnchorButton from '@/components/global/anchorButton'

export default {
    name: 'feature-vertical-block',
    mixins: [SectionMixin],
    components: {
        "anchor-button":AnchorButton
    },
    props: {
        title: String,
        description: String,
        link_text: String,
        link: String,
        center: Boolean,
        alternate: Boolean,
        bgColor: String,
        marginOff: Boolean,
        imgUrl: String,
        videoUrl: String,
        anchor_button: Object,
    },
    data: () => {
        return{
            isIntersecting: false,
            visible: false,
            autoplay: false,
        }
    },

    methods: {
        show() {
            if (this.visible) {
                setTimeout(() => {
                    this.autoplay = true
                }, 500);
                return
            }
            this.visible = true
        },
    }
}